import { setCookie } from '@cian/utils/lib/browser/cookie';
import { useInView } from '@cian/valuation-utils-component';
import { useEffect, useState } from 'react';

import { getCookie } from '../../../../browser/utils/cookie/getCookie';

export const ROUTE_TAB_ONBOARDING_COOKIE = 'hide_route_tab_onboarding';

export const useOnboardingCookie = () => {
  const [isAvailable, setIsAvailable] = useState(false);

  const { ref, inView } = useInView({
    threshold: 0,
    triggerOnce: true,
  });

  useEffect(() => {
    const onboardingCookie = getCookie(ROUTE_TAB_ONBOARDING_COOKIE);

    if (inView && !onboardingCookie) {
      setCookie(ROUTE_TAB_ONBOARDING_COOKIE, '1');

      setIsAvailable(true);
    }
  }, [inView]); // eslint-disable-line

  return { containerRef: ref, onboardingIsAvailable: isAvailable };
};
